import { useState } from 'react';
import { Box, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { formatUsageDate } from './UsageAnalytics';

export default function AdminReports({ users, catalog }) {
  const [days, setDays] = useState('30');
  const now = Date.now();
  const rows = users.flatMap(user => Object.entries(user.appsAccess || {}).filter(([, access]) => {
    const at = new Date(access?.expiresAt).getTime();
    return access?.enabled && Number.isFinite(at) && at > now && at <= now + Number(days) * 86400000;
  }).map(([app, access]) => ({ user, app, expiresAt: access.expiresAt }))).sort((a, b) => new Date(a.expiresAt) - new Date(b.expiresAt));
  return <Box>
    <Typography variant="h6" mb={2}>Próximos vencimientos de accesos</Typography>
    <TextField select label="Vencen en" size="small" value={days} onChange={e => setDays(e.target.value)} sx={{ minWidth: 180, mb: 2 }}><MenuItem value="7">7 días</MenuItem><MenuItem value="30">30 días</MenuItem></TextField>
    <Box sx={{ overflowX: 'auto' }}><Table size="small"><TableHead><TableRow><TableCell>Usuario</TableCell><TableCell>Herramienta</TableCell><TableCell>Vencimiento</TableCell></TableRow></TableHead><TableBody>
      {rows.map(row => <TableRow key={`${row.user._id}:${row.app}`}><TableCell>{row.user.nombre} {row.user.apellido}<Typography variant="caption" display="block">{row.user.email}</Typography></TableCell><TableCell>{catalog[row.app]?.title || row.app}</TableCell><TableCell>{formatUsageDate(row.expiresAt)}</TableCell></TableRow>)}
      {!rows.length && <TableRow><TableCell colSpan={3}>Sin vencimientos en este período.</TableCell></TableRow>}
    </TableBody></Table></Box>
  </Box>;
}
